{
  "setting_action_row": {
    "edit": "Edit"
  },
  "plan_upgrade_prompt": {
    "available_on_pro": "Available on Pro and Enterprise (and as an add-on)",
    "available_on_growth": "Available on Growth, Pro, and Enterprise",
    "change_plan": "Change plan"
  },
  "quoting_migration_modal": {
    "title": "Enable quotes",
    "alert_title": "These migrations are required for the new Quoting Engine.",
    "docs_link": "Learn more",
    "migration_sparkjs": {
      "title": "Migrate to Core Script 3.7 or higher",
      "description": "This will set your Core Script version to at least 3.7."
    },
    "migration_engine": {
      "title": "Migrate to the new Quoting Engine",
      "description": "Customer groups currently using the \"Request For Quote\" payment method will have it disabled and replaced with the new \"Quoting Engine\"."
    },
    "additional_info": "Please ensure you have updated your SparkLayer Core Script.",
    "migrate_and_enable": "Migrate and enable",
    "close": "Close"
  },
  "custom_email_domain_modal": {
    "title": "Edit custom email domain",
    "description": "Customise the user and domain used for outbound and inbound emails.",
    "toggle": {
      "label": "Enable custom email domain",
      "description": "Use your custom domain for emails sent to/from SparkLayer"
    },
    "fields": {
      "user": {
        "label": "Email user",
        "placeholder": "no-reply"
      },
      "domain": {
        "label": "Domain",
        "placeholder": "mail.sparklayer.io"
      }
    },
    "update_settings": "Update settings"
  }
}
